module.exports = __webpack_public_path__ + "static/img/talk_img_append_2.7a226136.png";